import { Component, effect } from '@angular/core';
import { ClubService } from '../../services/club.service';
import { WeatherWidgetComponent } from '../../../shared/components/weather-widget/weather-widget.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-homepage-widgets',
  imports: [WeatherWidgetComponent],
  templateUrl: './homepage-widgets.component.html',
  styleUrl: './homepage-widgets.component.scss',
})
export class HomepageWidgetsComponent {
  WEATHER_WIDGET = false;
  LOCATION_WIDGET = false;

  LOCATION_URL: SafeResourceUrl | undefined;

  constructor(
    private clubsService: ClubService,
    private sanitizer: DomSanitizer
  ) {
    effect(() => {
      const widget_flags = this.clubsService.flags();
      console.log(widget_flags);
      const theme = this.clubsService.theme();
      this.WEATHER_WIDGET = widget_flags ? widget_flags.weather_widget : false;
      this.LOCATION_WIDGET = widget_flags
        ? widget_flags.location_widget
        : false;
      const location_embed_url = theme ? theme.locations.map_location : '';

      if (location_embed_url && location_embed_url.length > 0) {
        this.LOCATION_URL =
          this.sanitizer.bypassSecurityTrustResourceUrl(location_embed_url);
      } else {
        this.LOCATION_WIDGET = false;
      }
    });
  }

  navigateTo(url: string): void {
    window.open(url, '_blank');
  }
}
